// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file rastro_tarea_ejecucion.proto (package sextante.rastro.tareaejecucion.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file rastro_tarea_ejecucion.proto.
 */
export const file_rastro_tarea_ejecucion: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Producto aplicado en una ejecucion y su dosis.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoItem
 */
export type TareaEjecucionDetalleProductoItem = Message<"sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoItem"> & {
  /**
   * @generated from field: string producto_id = 1;
   */
  productoId: string;

  /**
   * @generated from field: string producto_descripcion = 2;
   */
  productoDescripcion: string;

  /**
   * @generated from field: string unidad_medida = 3;
   */
  unidadMedida: string;

  /**
   * @generated from field: double dosis = 4;
   */
  dosis: number;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoItem.
 * Use `create(TareaEjecucionDetalleProductoItemSchema)` to create a new message.
 */
export const TareaEjecucionDetalleProductoItemSchema: GenMessage<TareaEjecucionDetalleProductoItem> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 0);

/**
 * Ejecucion registrada por un GPS de campo, a la que se le asigna una tarea y los productos usados.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.TareaEjecucionItem
 */
export type TareaEjecucionItem = Message<"sextante.rastro.tareaejecucion.v1.TareaEjecucionItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * Numero del GPS que registro la ejecucion.
   *
   * @generated from field: int32 gps_tracker_numero = 4;
   */
  gpsTrackerNumero: number;

  /**
   * Tarea asignada. Ausente si todavia no se asigno.
   *
   * @generated from field: optional string tarea_id = 5;
   */
  tareaId?: string | undefined;

  /**
   * @generated from field: optional string tarea_nombre = 6;
   */
  tareaNombre?: string | undefined;

  /**
   * Inicio de la ejecucion, ISO 8601.
   *
   * @generated from field: string fecha_inicio = 7;
   */
  fechaInicio: string;

  /**
   * Fin de la ejecucion, ISO 8601.
   *
   * @generated from field: string fecha_fin = 8;
   */
  fechaFin: string;

  /**
   * @generated from field: optional double distancia_km = 11;
   */
  distanciaKm?: number | undefined;

  /**
   * @generated from field: optional double velocidad_promedio_km_h = 12;
   */
  velocidadPromedioKmH?: number | undefined;

  /**
   * @generated from field: optional int32 muestras_ejecucion = 13;
   */
  muestrasEjecucion?: number | undefined;

  /**
   * @generated from field: repeated sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoItem detalles = 14;
   */
  detalles: TareaEjecucionDetalleProductoItem[];
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.TareaEjecucionItem.
 * Use `create(TareaEjecucionItemSchema)` to create a new message.
 */
export const TareaEjecucionItemSchema: GenMessage<TareaEjecucionItem> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 1);

/**
 * Pedido de las ejecuciones de una finca.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionesByFincaIdRequest
 */
export type ListTareaEjecucionesByFincaIdRequest = Message<"sextante.rastro.tareaejecucion.v1.ListTareaEjecucionesByFincaIdRequest"> & {
  /**
   * @generated from field: string finca_id = 1;
   */
  fincaId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionesByFincaIdRequest.
 * Use `create(ListTareaEjecucionesByFincaIdRequestSchema)` to create a new message.
 */
export const ListTareaEjecucionesByFincaIdRequestSchema: GenMessage<ListTareaEjecucionesByFincaIdRequest> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 2);

/**
 * Ejecuciones que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionesByFincaIdResponse
 */
export type ListTareaEjecucionesByFincaIdResponse = Message<"sextante.rastro.tareaejecucion.v1.ListTareaEjecucionesByFincaIdResponse"> & {
  /**
   * @generated from field: repeated sextante.rastro.tareaejecucion.v1.TareaEjecucionItem items = 1;
   */
  items: TareaEjecucionItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionesByFincaIdResponse.
 * Use `create(ListTareaEjecucionesByFincaIdResponseSchema)` to create a new message.
 */
export const ListTareaEjecucionesByFincaIdResponseSchema: GenMessage<ListTareaEjecucionesByFincaIdResponse> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 3);

/**
 * Ejecuciones cuyos recorridos se piden: las de un dia. Maximo 100 por pedido.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionRecorridosRequest
 */
export type ListTareaEjecucionRecorridosRequest = Message<"sextante.rastro.tareaejecucion.v1.ListTareaEjecucionRecorridosRequest"> & {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionRecorridosRequest.
 * Use `create(ListTareaEjecucionRecorridosRequestSchema)` to create a new message.
 */
export const ListTareaEjecucionRecorridosRequestSchema: GenMessage<ListTareaEjecucionRecorridosRequest> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 4);

/**
 * Recorrido de una ejecucion. Geometrias en WKB (bytes), no GeoJSON: mismo criterio que fincas y lotes
 * en login.proto, para que pesen menos. ultima_actualizacion es la de la ejecucion: la app vuelve a
 * pedir un recorrido solo si la ejecucion cambio despues de guardarlo.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.TareaEjecucionRecorridoItem
 */
export type TareaEjecucionRecorridoItem = Message<"sextante.rastro.tareaejecucion.v1.TareaEjecucionRecorridoItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 ultima_actualizacion = 2;
   */
  ultimaActualizacion: bigint;

  /**
   * WKB MultiLineString, siempre presente
   *
   * @generated from field: bytes muestras_automaticas = 3;
   */
  muestrasAutomaticas: Uint8Array;

  /**
   * WKB MultiPoint
   *
   * @generated from field: optional bytes ejecucion = 4;
   */
  ejecucion?: Uint8Array | undefined;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.TareaEjecucionRecorridoItem.
 * Use `create(TareaEjecucionRecorridoItemSchema)` to create a new message.
 */
export const TareaEjecucionRecorridoItemSchema: GenMessage<TareaEjecucionRecorridoItem> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 5);

/**
 * Solo las ejecuciones vigentes de fincas del cliente de la sesion; los ids ajenos o eliminados se omiten.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionRecorridosResponse
 */
export type ListTareaEjecucionRecorridosResponse = Message<"sextante.rastro.tareaejecucion.v1.ListTareaEjecucionRecorridosResponse"> & {
  /**
   * @generated from field: repeated sextante.rastro.tareaejecucion.v1.TareaEjecucionRecorridoItem items = 1;
   */
  items: TareaEjecucionRecorridoItem[];
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.ListTareaEjecucionRecorridosResponse.
 * Use `create(ListTareaEjecucionRecorridosResponseSchema)` to create a new message.
 */
export const ListTareaEjecucionRecorridosResponseSchema: GenMessage<ListTareaEjecucionRecorridosResponse> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 6);

/**
 * Producto a registrar en una ejecucion y su dosis.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoRequestItem
 */
export type TareaEjecucionDetalleProductoRequestItem = Message<"sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoRequestItem"> & {
  /**
   * @generated from field: string producto_id = 1;
   */
  productoId: string;

  /**
   * @generated from field: double dosis = 2;
   */
  dosis: number;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoRequestItem.
 * Use `create(TareaEjecucionDetalleProductoRequestItemSchema)` to create a new message.
 */
export const TareaEjecucionDetalleProductoRequestItemSchema: GenMessage<TareaEjecucionDetalleProductoRequestItem> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 7);

/**
 * Igual que REST: solo actualizacion (id y tarea_id obligatorios, rechaza creacion). Geometrias,
 * metricas y fechas no se modifican por esta via.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.GuardarTareaEjecucionRequest
 */
export type GuardarTareaEjecucionRequest = Message<"sextante.rastro.tareaejecucion.v1.GuardarTareaEjecucionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tarea_id = 2;
   */
  tareaId: string;

  /**
   * @generated from field: repeated sextante.rastro.tareaejecucion.v1.TareaEjecucionDetalleProductoRequestItem detalles = 3;
   */
  detalles: TareaEjecucionDetalleProductoRequestItem[];
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.GuardarTareaEjecucionRequest.
 * Use `create(GuardarTareaEjecucionRequestSchema)` to create a new message.
 */
export const GuardarTareaEjecucionRequestSchema: GenMessage<GuardarTareaEjecucionRequest> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 8);

/**
 * Ejecucion a eliminar.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.EliminarTareaEjecucionRequest
 */
export type EliminarTareaEjecucionRequest = Message<"sextante.rastro.tareaejecucion.v1.EliminarTareaEjecucionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.EliminarTareaEjecucionRequest.
 * Use `create(EliminarTareaEjecucionRequestSchema)` to create a new message.
 */
export const EliminarTareaEjecucionRequestSchema: GenMessage<EliminarTareaEjecucionRequest> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 9);

/**
 * Sin datos: que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.EliminarTareaEjecucionResponse
 */
export type EliminarTareaEjecucionResponse = Message<"sextante.rastro.tareaejecucion.v1.EliminarTareaEjecucionResponse"> & {
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.EliminarTareaEjecucionResponse.
 * Use `create(EliminarTareaEjecucionResponseSchema)` to create a new message.
 */
export const EliminarTareaEjecucionResponseSchema: GenMessage<EliminarTareaEjecucionResponse> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 10);

/**
 * Tarea a asignar a una ejecucion.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.AsignacionTareaEjecucionItem
 */
export type AsignacionTareaEjecucionItem = Message<"sextante.rastro.tareaejecucion.v1.AsignacionTareaEjecucionItem"> & {
  /**
   * @generated from field: string tarea_ejecucion_id = 1;
   */
  tareaEjecucionId: string;

  /**
   * @generated from field: string tarea_id = 2;
   */
  tareaId: string;
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.AsignacionTareaEjecucionItem.
 * Use `create(AsignacionTareaEjecucionItemSchema)` to create a new message.
 */
export const AsignacionTareaEjecucionItemSchema: GenMessage<AsignacionTareaEjecucionItem> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 11);

/**
 * Asignacion en masa, atomica en el server: minimo 1 asignacion, sin tarea_ejecucion_id repetido.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.AsignarTareaEjecucionRequest
 */
export type AsignarTareaEjecucionRequest = Message<"sextante.rastro.tareaejecucion.v1.AsignarTareaEjecucionRequest"> & {
  /**
   * @generated from field: repeated sextante.rastro.tareaejecucion.v1.AsignacionTareaEjecucionItem asignaciones = 1;
   */
  asignaciones: AsignacionTareaEjecucionItem[];
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.AsignarTareaEjecucionRequest.
 * Use `create(AsignarTareaEjecucionRequestSchema)` to create a new message.
 */
export const AsignarTareaEjecucionRequestSchema: GenMessage<AsignarTareaEjecucionRequest> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 12);

/**
 * Sin datos: que el rpc no falle ya indica que se asignaron todas.
 *
 * @generated from message sextante.rastro.tareaejecucion.v1.AsignarTareaEjecucionResponse
 */
export type AsignarTareaEjecucionResponse = Message<"sextante.rastro.tareaejecucion.v1.AsignarTareaEjecucionResponse"> & {
};

/**
 * Describes the message sextante.rastro.tareaejecucion.v1.AsignarTareaEjecucionResponse.
 * Use `create(AsignarTareaEjecucionResponseSchema)` to create a new message.
 */
export const AsignarTareaEjecucionResponseSchema: GenMessage<AsignarTareaEjecucionResponse> = /*@__PURE__*/
  messageDesc(file_rastro_tarea_ejecucion, 13);

/**
 * Ejecuciones de tareas de rastro de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja de
 * servicios. No crea ejecuciones: las genera el GPS Tracker. Permite asignar tarea y productos, dar de baja
 * y asignar tareas en masa. Requiere sesion de la app Cliente.
 * 
 * Pertenencia (2026-09-30): solo trabaja con ejecuciones de fincas del cliente de la sesion. Una finca o
 * ejecucion ajena responde igual que una inexistente. La tarea asignada tiene que ser global o del cliente.
 * 
 * Nombres de mensaje con prefijo de dominio: ver terceros_lote.proto para el gotcha real del
 * csharp_namespace compartido — revisar que un nombre no exista ya en otro .proto antes de usarlo.
 *
 * @generated from service sextante.rastro.tareaejecucion.v1.TareaEjecucionService
 */
export const TareaEjecucionService: GenService<{
  /**
   * Ejecuciones de una finca del cliente, por delta: solo las que cambiaron desde ultima_sincronizacion.
   * No trae los recorridos (ver ListRecorridos). Finca ajena o inexistente: NotFound.
   *
   * @generated from rpc sextante.rastro.tareaejecucion.v1.TareaEjecucionService.ListByFincaId
   */
  listByFincaId: {
    methodKind: "unary";
    input: typeof ListTareaEjecucionesByFincaIdRequestSchema;
    output: typeof ListTareaEjecucionesByFincaIdResponseSchema;
  },
  /**
   * Asigna la tarea y reemplaza el detalle de productos de una ejecucion del cliente. Ejecucion ajena o
   * inexistente: NotFound. Tarea que no es global ni del cliente: InvalidArgument.
   *
   * @generated from rpc sextante.rastro.tareaejecucion.v1.TareaEjecucionService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarTareaEjecucionRequestSchema;
    output: typeof TareaEjecucionItemSchema;
  },
  /**
   * Baja logica de una ejecucion del cliente. Si no existe o es ajena no hace nada.
   *
   * @generated from rpc sextante.rastro.tareaejecucion.v1.TareaEjecucionService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarTareaEjecucionRequestSchema;
    output: typeof EliminarTareaEjecucionResponseSchema;
  },
  /**
   * Asigna tareas a varias ejecuciones del cliente en un solo pedido. Todas tienen que existir y ser suyas
   * (NotFound si no), y cada tarea tiene que ser global o del cliente (InvalidArgument si no).
   *
   * @generated from rpc sextante.rastro.tareaejecucion.v1.TareaEjecucionService.AsignarTarea
   */
  asignarTarea: {
    methodKind: "unary";
    input: typeof AsignarTareaEjecucionRequestSchema;
    output: typeof AsignarTareaEjecucionResponseSchema;
  },
  /**
   * Recorridos (2026-09-30): el listado ya no trae las geometrias, que hacian pesar la descarga inicial
   * (un cliente con un ano y seis GPS bajaba unos 20 MB). ListByFincaId sigue sincronizando por delta por
   * finca, sin cambios. La app pide los recorridos de las ejecuciones del dia que abre y los guarda; los
   * vuelve a pedir solo si el delta del listado trajo una ultima_actualizacion mas nueva. Solo devuelve
   * ejecuciones de fincas del cliente de la sesion.
   *
   * @generated from rpc sextante.rastro.tareaejecucion.v1.TareaEjecucionService.ListRecorridos
   */
  listRecorridos: {
    methodKind: "unary";
    input: typeof ListTareaEjecucionRecorridosRequestSchema;
    output: typeof ListTareaEjecucionRecorridosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_rastro_tarea_ejecucion, 0);

